<template>
  <g
    v-for="(data, dataKey) in fields"
    :id="data.id"
    :key="`fw-signing-element-${data.id}`"
    v-tippy
    :content="tippyContent(data)"
    :status="data.status"
    :transform="`matrix(1,0,0,1, ${data.x}, ${data.y})`"
    class="fw-signing-element"
    draggable="true"
    opacity="1"
    selectable
    @click="emit('check-coords', $event)"
    @mousedown="emit('select-element', $event, data)"
  >
    <DocumentFieldRenderer
      :data-key="Number(dataKey)"
      :determine-display-font-size="determineDisplayFontSize"
      :determine-text-lines="determineTextLines"
      :determine-y-text-offset="determineYTextOffset"
      :element-class-object="elementClassObject"
      :element-fill-color="elementFillColor"
      :field="data"
      @signer-clicked="emit('signer-clicked', $event)"
    />
  </g>
</template>

<script lang="ts" setup>
import type {ESignerFieldData} from '@/types/esign';

import DocumentFieldRenderer from '@/components/documentsV2/DocumentFieldRenderer.vue';

/* eslint-disable no-unused-vars */
defineProps<{
  fields: ESignerFieldData[];
  tippyContent: (_: ESignerFieldData) => string;
  elementClassObject: (_: ESignerFieldData) => unknown;
  elementFillColor: (_: ESignerFieldData) => string;
  determineDisplayFontSize: (_: ESignerFieldData) => number;
  determineYTextOffset: (_: ESignerFieldData) => number;
  determineTextLines: (_: ESignerFieldData) => string[];
}>();
/* eslint-enable no-unused-vars */

const emit = defineEmits<{
  'check-coords': [event: MouseEvent];
  'select-element': [event: MouseEvent, field: ESignerFieldData];
  'signer-clicked': [field: ESignerFieldData];
}>();
</script>

